export default __webpack_public_path__ + "static/media/Punto_00_Finocchietti_FRA_Def.42f374db.aac";